module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }, {
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "id": "page"
    }
  }, [(!_vm.login) ? _c('loginArea') : _vm._e(), _vm._v(" "), (_vm.login) ? _c('div', {
    staticClass: "wrapper",
    attrs: {
      "id": "siteWrapper"
    }
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/#"
    }
  }, [_vm._v("\n                    HR融担平台\n                ")]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav hidden-xs"
  }, [((_vm.role_oper_type == 2 || _vm.role_oper_type == 3)) ? _c('li', {
    class: _vm.areaName == 'home' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/homePage"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("  主页")])], 1) : _vm._e(), _vm._v(" "), (_vm.top_chedaiTab) ? _c('li', {
    class: {
      "active": (_vm.areaName == "chedai")
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.top_chedaiTab.href
    }
  }, [_c('i', {
    class: _vm.top_chedaiTab.icon
  }), _vm._v(" " + _vm._s(_vm.top_chedaiTab.name) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.topAdminTab) ? _c('li', {
    class: {
      "active": (_vm.areaName == "erp")
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.topAdminTab.href
    }
  }, [_c('i', {
    class: _vm.topAdminTab.icon
  }), _vm._v("  " + _vm._s(_vm.topAdminTab.name) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.topCarTab) ? _c('li', {
    class: {
      "active": (_vm.areaName == "car")
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.topCarTab.href
    }
  }, [_c('i', {
    class: _vm.topCarTab.icon
  }), _vm._v("  " + _vm._s(_vm.topCarTab.name) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.topFastDebit) ? _c('li', {
    class: {
      "active": (_vm.areaName == "csd")
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.topFastDebit.href
    }
  }, [_c('i', {
    class: _vm.topFastDebit.icon
  }), _vm._v("  " + _vm._s(_vm.topFastDebit.name) + "\n                            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.topBackTab) ? _c('li', [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.topTodo) ? _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.topTodo.href
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.topTodo.name) + "   "), _c('i', {
    class: _vm.topTodo.icon
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.taskCount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.topMsg) ? _c('li', [_c('router-link', {
    attrs: {
      "to": _vm.topMsg.href
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.topMsg.name) + "   "), _c('i', {
    class: _vm.topMsg.icon
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.msgCount))])])], 1) : _vm._e(), _vm._v(" "), (_vm.topNotify) ? _c('li', {
    attrs: {
      "id": "infoCounter"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/user/taskNotify"
    }
  }, [_vm._v("\n                                    估价提醒   "), _c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.priceCount))])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "static/img/avatar.png",
      "alt": _vm.user.name
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "static/img/avatar.png",
      "alt": _vm.user.name
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                                            " + _vm._s(_vm.user.name) + "\n                                            "), _c('small', [_vm._v(_vm._s(_vm.user.depart_name) + " - " + _vm._s(_vm.user.role_name))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "to": "/user/info"
    }
  }, [_vm._v("个人资料\n                                            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.userSignOut.apply(null, arguments)
      }
    }
  }, [_vm._v("退出")])])])])])])])])]), _vm._v(" "), _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('sidebarArea', {
    attrs: {
      "sideparamas": _vm.areaName
    }
  })], 1), _vm._v(" "), _c('router-view', {
    staticClass: "content-wrapper"
  })], 1) : _vm._e(), _vm._v(" "), _c('createWin', {
    attrs: {
      "visible": _vm.showCreateWin
    },
    on: {
      "closed": function($event) {
        _vm.showCreateWin = false
      }
    }
  }), _vm._v(" "), _c('createFile', {
    attrs: {
      "visible": _vm.showCreateFile
    },
    on: {
      "closed": function($event) {
        _vm.showCreateFile = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "title": "展开边栏",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("展开边栏")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v("  返回")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78dad290!./~/vue-loader/lib/selector.js?type=template&index=0!./src/chedai.vue
// module id = 1283
// module chunks = 105